<template>
  <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false" v-loading="loading">
    <el-form v-if="doEdit" label-position="left" ref="EditCurriculumListForm" :rules="editCurriculumListFormRule"
             label-width="100px" :model="editCurriculumListForm">
      <div style="background: #FFFFFF;text-align: center">
        <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
        <h1 class="acr-dialog-title">修改课程信息</h1>
        <div class="acr-dialog-form">
          <el-form-item label="ID" prop="id">
            <el-input v-model="editCurriculumListForm.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="课程名" prop="name">
            <el-input v-model="editCurriculumListForm.name"></el-input>
          </el-form-item>
          <el-form-item label="课程缩略图" prop="coverPhoto">
            <el-input v-model="editCurriculumListForm.coverPhoto" disabled></el-input>
          </el-form-item>
          <el-upload class="avatar-uploader" :show-file-list="false" :http-request="uploadFile" action="">
            <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="pic">
            <em v-else class="el-icon-plus avatar-uploader-icon"></em>
          </el-upload>
          <el-form-item label="课程简介" prop="remark">
            <el-input type="textarea" v-model="editCurriculumListForm.remark"></el-input>
          </el-form-item>
          <el-button style="position: absolute;right: 0" v-on:click="doSubmitCurriculum">提交</el-button>
        </div>
      </div>
    </el-form>
    <el-form v-else label-position="left" ref="AddCurriculumListForm" :rules="addCurriculumListFormRule"
             label-width="100px" :model="addCurriculumListForm">
      <div style="background: #FFFFFF;text-align: center">
        <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
        <h1 class="acr-dialog-title">
          添加课程</h1>
        <div class="acr-dialog-form">
          <el-form-item label="课程名" prop="name">
            <el-input v-model="addCurriculumListForm.name"></el-input>
          </el-form-item>
          <el-form-item label="课程缩略图" prop="coverPhoto">
            <el-input v-model="addCurriculumListForm.coverPhoto" disabled></el-input>
          </el-form-item>
          <el-upload class="avatar-uploader" :show-file-list="false" :http-request="uploadFile" action="">
            <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="pic">
            <em v-else class="el-icon-plus avatar-uploader-icon"></em>
          </el-upload>
          <el-form-item label="课程简介" prop="remark">
            <el-input type="textarea" v-model="addCurriculumListForm.remark"></el-input>
          </el-form-item>
          <el-button style="position: absolute;right: 0" v-on:click="doSubmitCurriculum">提交</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";

export default {
  name: "EditCurriculumListDialog",
  data() {
    const validateId = (rule, value, callback) => {
      if (value !== this.bufferId) {
        callback(new Error("????"))
      }
      callback();
    }
    const validateRemark = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入课程简介'))
      } else {
        if (value.length < 2 || value.length > 256) {
          callback(new Error('请输入正确格式的课程简介,长度[2-256]'));
        }
        callback();
      }
    }
    return {
      loading: false,
      dialogFormVisible: false,
      doEdit: false,
      editCurriculumListForm: {
        id: '',
        name: '',
        coverPhoto: '',
        remark: ''
      },
      addCurriculumListForm: {
        name: '',
        coverPhoto: '',
        remark: ''
      },
      editCurriculumListFormRule: {
        id: [
          {validator: validateId, trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入课程名', trigger: 'blur'},
          {min: 2, max: 32, message: '请输入正确长度的课程名[2-32]', trigger: 'blur'}
        ],
        coverPhoto: [
          {required: true, message: '请上传课程封面', trigger: 'blur'}
        ],
        remark: [
          {validator: validateRemark, trigger: 'blur'}
        ]
      },
      addCurriculumListFormRule: {
        name: [
          {required: true, message: '请输入课程名', trigger: 'blur'},
          {min: 2, max: 32, message: '请输入正确长度的课程名[2-32]', trigger: 'blur'}
        ],
        coverPhoto: [
          {required: true, message: '请上传课程封面', trigger: 'blur'}
        ],
        remark: [
          {validator: validateRemark, trigger: 'blur'}
        ]
      },
      bufferId: '',
      imageUrl: ''
    }
  },
  methods: {
    enterEdit() {
      this.loading = true;
      AxiosBase.axiosGet("/curriculum-ad/get-curriculum-list", {
        params: {
          key: this.bufferId
        }
      }).then(response => {
        if (response !== 0) {
          this.editCurriculumListForm = response.data[0];
          this.imageUrl = this.editCurriculumListForm.coverPhoto;
          this.loading = false;
        } else {
          Message({
            showClose: true,
            message: '无法获取课程信息',
            type: 'error'
          });
          this.dialogFormVisible = false;
        }
      })
    },
    doSubmitCurriculum() {
      if (this.doEdit) {
        this.$refs['EditCurriculumListForm'].validate((valid) => {
          if (valid) {
            AxiosBase.axiosPost("/curriculum-ad/edit-curriculum-list", this.editCurriculumListForm).then(response => {
              if (response !== 0) {
                this.$parent.getCurriculumListData();
                this.$refs['EditCurriculumListForm'].resetFields();
                this.imageUrl = '';
                this.dialogFormVisible = false;
                Message({
                  showClose: true,
                  message: '修改课程信息成功',
                  type: 'success'
                });
              }
            })
          }
        });
      } else {
        this.$refs['AddCurriculumListForm'].validate((valid) => {
          if (valid) {
            AxiosBase.axiosPut("/curriculum-ad/add-curriculum-list", this.addCurriculumListForm).then(response => {
              if (response !== 0) {
                this.$parent.getCurriculumListData();
                this.$refs['AddCurriculumListForm'].resetFields();
                this.imageUrl = '';
                this.dialogFormVisible = false;
                Message({
                  showClose: true,
                  message: '添加课程成功',
                  type: 'success'
                });
              }
            })
          }
        });
      }
    },
    uploadFile(fileObj) {
      let formData = new FormData();
      formData.set("file", fileObj.file);
      AxiosBase.axiosPost("/ff/upload-admin", formData, {
        headers: {
          "Content-type": "multipart/form-data"
        }
      }).then(response => {
        if (response !== 0) {
          const imgPath = "https://img.blendermagic.cn/admin/" + response.data
          this.addCurriculumListForm.coverPhoto = imgPath;
          this.editCurriculumListForm.coverPhoto = imgPath;
          this.imageUrl = imgPath;
        }
      })
    }
  }
}
</script>

<style scoped>

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 250px;
  height: 180px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 250px;
  height: 180px;
  display: block;
}
</style>